import React from 'react';
import { CloseProfile } from './CloseProfile';

class ProfileHeader extends React.Component {
    render() {
        const name = this.props.name;
        const resetProfile = this.props.resetProfile;
        const duplicate = this.props.duplicate;
        return(
            <div className="profile-header">
                <h3 className="profile-name">{name}</h3>
                <CloseProfile reset={resetProfile} duplicate={duplicate} />
            </div>
        )
    }
}
export default ProfileHeader;


// WEBPACK FOOTER //
// ./src/helpers/uiComponents/ProfileHeader.js